import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import { getPatientDetailData } from 'store/patientDetail/patinetDetailAction';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import moment from 'moment';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import CommonToast from 'components/commom/CommonToast';
import SkinAnalyserImg from 'assets/images/Enterprise/Skin Analyser.png';
import SkinConcernImg from 'assets/images/Enterprise/Skin Concern Identifier.png';
import HairAnalyserImg from 'assets/images/Enterprise/Hair Analyser.png';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import Loader from 'components/commom/Loader';
import { FormattedMessage } from 'react-intl';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import LabelWithInput from 'components/commom/LabelWithInput';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import { scanResult, userDetail } from 'routes/AppUrls';
import { getScannedImageCallAPI } from 'store/getScannedImage/action';
import { getEnterpriseScannedImageCallAPI } from 'store/Enterprise/staff/getEnterpriseScannedImage/action';
import {
  basicDetailsValue,
  SCAN_DETAILS,
  SCAN_RESULT,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';

const StaffDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const userRole = getUserRole();

  const [formData, setFormData] = useState({
    search: '',
    startDate: '',
    endDate: '',
  });
  const [selectedDate, setSelectedDate] = useState({
    id: 'Today',
    name: 'Today',
  });
  const [loading, setLoading] = useState(true);

  const particularEnterprise = useSelector(
    (state) => state?.basicDetailsValueReducer?.particularEnterprise
  );
  const particularStaff = useSelector(
    (state) => state?.basicDetailsValueReducer?.particularStaff
  );
  const scanImageList = useSelector(
    (state) => state?.getEnterpriseScannedImageReducer?.users?.data
  );
  const scanImageLoader = useSelector(
    (state) => state?.getEnterpriseScannedImageReducer?.loading
  );
  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  const analysisData = [
    { id: 1, name: 'Skin Analysis', img: SkinAnalyserImg },
    { id: 2, name: 'SkinConcern Identifier', img: SkinConcernImg },
    { id: 3, name: 'Hair Analysis', img: HairAnalyserImg },
  ];

  const selectDateList = [
    {
      id: 'Today',
      name: 'Today',
    },
    {
      id: 'Yesterday',
      name: 'Yesterday',
    },
    {
      id: 'Last 7 Days',
      name: 'Last 7 Days',
    },
    {
      id: 'Last 15 Days',
      name: 'Last 15 Days',
    },
    {
      id: 'Last 30 Days',
      name: 'Last 30 Days',
    },
    {
      id: 'Custom',
      name: 'Custom',
    },
  ];

  useEffect(() => {
    if (particularStaff?.id) {
      getScannedData(
        '',
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      );
    }
  }, [particularStaff]);

  const getScannedData = (search, startDate, endDate) => {
    dispatch(
      getEnterpriseScannedImageCallAPI(
        `?staff_id=${particularStaff?.id}&enterprise_id=${userRole === 'enterprise-admin' ? enterpriseData?.enterprise?.enterprise_id : particularEnterprise?.id}&start_date=${startDate}&end_date=${endDate}${search ? `&search_text=${search}` : ``}`,
        {
          run: true,
          handleFunction: (res) => {
            setLoading(false);
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
            setLoading(false);
          },
        }
      )
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (e) => {
    setSelectedDate(e?.target?.value);

    switch (e?.target?.value?.id) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        //   getRevenueList(
        //     formData?.type,
        //     moment().format('YYYY-MM-DD'),
        //     moment().format('YYYY-MM-DD')
        //   );
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;
      case 'Custom':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));
      default:
        break;
    }
  };

  const handleApply = () => {
    getScannedData(formData?.search, formData?.startDate, formData?.endDate);
  };

  const handleViewAnalysis = (data) => {
    dispatch(basicDetailsValue(SCAN_DETAILS, { id: data?.scan_by_id }));
    dispatch(basicDetailsValue(SCAN_RESULT, data));
    if (userRole === 'enterprise-admin') {
      navigate(scanResult(locale));
    } else {
      navigate(userDetail(locale));
    }
  };

  const groupByDate = (list) => {
    if (!Array.isArray(list)) return {};
    return list.reduce((acc, item) => {
      const date = moment(item.scanning_date).format('YYYY-MM-DD');
      if (!acc[date]) acc[date] = [];
      acc[date].push(item);
      return acc;
    }, {});
  };

  const groupedScanImages = groupByDate(scanImageList);

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          {userRole === 'enterprise-admin' ? (
            <div className="flex pb-16">
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Staff Members
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Staff Details
              </div>
            </div>
          ) : (
            <div className="flex pb-16">
              <div className="fs-12 lh-24 family_outfit_regular_400">
                Enterprise
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Enterprise Details
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Staff Details
              </div>
            </div>
          )}
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Staff Details
                </div>
              </div>
              <Row className="m-0 p-0 d-flex align-items-center">
                <Col md={4} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {loading ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={ImageNull}
                          alt="Uploaded profile"
                          className={false ? 'uploadPhoto' : ''}
                        />
                      )}
                    </div>
                    <div className="pl-12">
                      {loading ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <p className="p-0 m-0 fs-20 family_outfit_medium_500 lh-252 fc-202224 break-all">
                          {particularStaff?.name}
                        </p>
                      )}
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'12px'}
                        />
                      ) : (
                        <p className="pt-12 m-0 fs-14 family_outfit_regular_400 lh-176 fc-A4AAB2">
                          Staff ID:
                          <span className="fs-14 family_outfit_medium_500 lh-176 fc-202224 ml-[8px]">
                            {particularStaff?.id}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={8} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={5} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Company Name
                      </div>
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {userRole === 'enterprise-admin'
                            ? enterpriseData?.enterprise?.enterprise_name
                            : particularEnterprise?.name}
                        </div>
                      )}
                    </Col>
                    <Col md={7} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Contact Info
                      </div>
                      <Stack
                        direction="horizontal"
                        gap={5}
                        className="items-center p-0"
                      >
                        {loading ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MobileIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all">
                              {particularStaff?.contact_number}
                            </div>
                          </div>
                        )}
                        {loading ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MailIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                              {particularStaff?.email}
                            </div>
                          </div>
                        )}
                      </Stack>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {!loading && (
            <div className="my-[16px]">
              <div className="flex flex-wrap gap-[12px]">
                {analysisData?.map((item, index) => (
                  <div
                    key={index}
                    className="bg-[#FAF1EC] rounded-[4px] px-[10px] py-[15px] w-full max-w-[250px]"
                  >
                    <div className="flex items-center gap-[4px]">
                      <Image src={item?.img} alt="icon" />
                      <div className="text-[16px] text-[#998A7B] family_outfit_regular_400 lh-176">
                        {item?.name}:
                      </div>
                      <div className="text-[16px] text-[#292D32] family_outfit_medium_500 lh-176">
                        {item?.id === 1
                          ? particularStaff?.skin_analyser_count
                          : item?.id === 2
                            ? particularStaff?.skin_concern_identifier_count
                            : item?.id === 3
                              ? particularStaff?.hair_analyser_count
                              : ''}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className={`${loading ? '' : 'bg-white'} px-[24px] pb-[24px]"`}>
            {!loading && (
              <div className="flex flex-wrap gap-x-[20px]">
                <div className="mt-[17px] w-full max-w-[180px]">
                  <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                    Search:
                  </div>
                  <div>
                    <LabelWithInput
                      // label=""
                      placeholder="Search"
                      name="search"
                      type="text"
                      marginLabelTop={'0'}
                      marginTop={'0'}
                      bgColor="white"
                      placeholdercolor="#000000"
                      value={formData?.search}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                </div>
                <div className="mt-[17px] w-full max-w-[180px]">
                  <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                    {'Select Date:'}
                  </div>
                  <div>
                    <SelectInputBorder
                      placeholder={'Select Date'}
                      name={'selectDate'}
                      value={selectedDate?.id || ''}
                      data={selectDateList}
                      onChange={(e) => handleDateChange(e)}
                      background={'#FFFFFF'}
                      colorIcon={'#292D32'}
                      placeholderColor={'#292D32'}
                    />
                  </div>
                </div>
                {selectedDate?.id === 'Custom' && (
                  <>
                    <div>
                      <LabelWithInput
                        label="Start Date"
                        type="date"
                        name="startDate"
                        value={formData?.startDate}
                        disabled={false}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                        marginTop={0}
                        sx={{ mt: 0 }}
                      />
                    </div>
                    <div>
                      <LabelWithInput
                        label="End Date"
                        type="date"
                        name="endDate"
                        value={formData?.endDate}
                        disabled={false}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </div>
                  </>
                )}
                <div className="mt-[46px] w-full max-w-[180px]">
                  <div
                    className="fs-16 family_outfit_medium_500 lh-16 bg-[#375241] h-[47px] flex items-center justify-center text-white cursor-pointer w-full"
                    onClick={() => {
                      handleApply();
                    }}
                  >
                    Apply
                  </div>
                </div>
              </div>
            )}
            {!loading && (
              <div className="mt-[12px]">
                <div className="text-[16px] text-[#A39688] family_outfit_regular_400 lh-176">
                  Your images are securely encrypted and private, accessible
                  only to you.
                </div>
              </div>
            )}
            <div className="mt-[20px]">
              {loading || scanImageLoader ? (
                <Loader marginTop={'10vh'} />
              ) : (
                <div>
                  {scanImageList && scanImageList?.length > 0 ? (
                    <div>
                      {Object.entries(groupedScanImages).map(
                        ([date, images]) => (
                          <div key={date} className="mb-[20px]">
                            <div className="text-[20px] text-[#292D32] family_outfit_medium_500 lh-176">
                              {moment(date).format('MMM D, YYYY')}
                            </div>
                            <div className="mt-[12px] flex flex-wrap gap-[16px]">
                              {images.map((item, idx) => (
                                <div className="flex items-stretch" key={idx}>
                                  <div
                                    className="bg-white rounded-[10px] overflow-hidden shadow-md flex flex-col cursor-pointer"
                                    style={{ width: 220, height: 342 }}
                                    onClick={() => {
                                      handleViewAnalysis(item);
                                    }}
                                  >
                                    <div
                                      className="relative flex-1 flex items-center justify-center bg-grey-100 px-[5px] pt-[5px]"
                                      style={{ minHeight: 0 }}
                                    >
                                      <img
                                        className="w-full h-full object-contain"
                                        src={item.original_image}
                                        alt="scanned"
                                        style={{
                                          maxHeight: '100%',
                                          maxWidth: '100%',
                                        }}
                                      />
                                    </div>
                                    <div className="bg-[#874529] py-[20px] w-full text-center cursor-pointer">
                                      <div className="text-[20px] text-white family_outfit_regular_400 lh-176">
                                        View Analysis
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center items-center py-[20px]">
                      <Image
                        src={EmptyScreen}
                        alt="icon"
                        width={'301px'}
                        height={'224px'}
                      />
                      <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                        Nothing here yet
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StaffDetail;
